/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemainingMaxDiscount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function RemainingMaxDiscount({
  children,
  viewPath = "/DesignSystem/CaseCloserPaymentPlans/PaymentPlans/Content/PaymentPlan/Info/RemainingMaxDiscount"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let setupMaxDiscountValueData = fromData.useDataValue({ viewPath,
context: 'setup',
path: 'max_discount',
})
let setupTreatmentDiscountsValueData = fromData.useDataValue({ viewPath,
context: 'setup',
path: 'treatment_discounts',
})
let aggregateData = fromHelpers.getRemainingMaxDiscount(setupMaxDiscountValueData, setupTreatmentDiscountsValueData)
  return (<React.Fragment
>
<div
  data-testid="RemainingMaxDiscount.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Maximum discount possible"
 weight="medium"
 color={dtColorsNeutral500}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="setup.max_discount"
 data="setup.treatment_discounts"
 aggregate="helpers.js getRemainingMaxDiscount"
 text={aggregateData}
 weight="medium"
/>
</div>
{children}
</React.Fragment>)
}